package com.swetdot.swetgram.data.legal

import com.swetdot.swetgram.data.api.ApiClient
import com.swetdot.swetgram.protocol.dto.LegalAcceptanceRequest
import com.swetdot.swetgram.protocol.dto.LegalStatus
import io.ktor.client.request.setBody

class LegalRepository(private val api: ApiClient) {
    suspend fun status(): LegalStatus = api.get("legal/status")

    suspend fun accept(status: LegalStatus): LegalStatus = api.post("legal/acceptance") {
        setBody(
            LegalAcceptanceRequest(
                acceptedTermsVersion = status.documents.termsVersion,
                acceptedPrivacyVersion = status.documents.privacyVersion,
                ageConfirmed = true,
            ),
        )
    }
}
